export default "__VITE_ASSET__BRLQonBC__"